var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcCategories(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.75 22.5H14.25C13.8358 22.5 13.5 22.1642 13.5 21.75V14.25C13.5 13.8358 13.8358 13.5 14.25 13.5H21.75C22.1642 13.5 22.5 13.8358 22.5 14.25V21.75C22.5 22.1642 22.1642 22.5 21.75 22.5ZM15 21H21V15H15V21Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 22.5C3.51877 22.5 1.5 20.4812 1.5 18C1.5 15.5188 3.51877 13.5 6 13.5C8.48123 13.5 10.5 15.5188 10.5 18C10.5 20.4812 8.48123 22.5 6 22.5ZM6 15C4.3458 15 3 16.3458 3 18C3 19.6542 4.3458 21 6 21C7.6542 21 9 19.6542 9 18C9 16.3458 7.6542 15 6 15Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 10.5H7.5C7.2297 10.5 6.98055 10.3546 6.84742 10.1195C6.7143 9.8844 6.71775 9.59587 6.85695 9.36413L11.3584 1.86165C11.5037 1.61947 11.7519 1.5 12 1.5C12.2481 1.5 12.4963 1.61947 12.6416 1.86165L17.1431 9.36413C17.2822 9.59587 17.2857 9.8844 17.1526 10.1195C17.0194 10.3546 16.7702 10.5 16.5 10.5ZM8.82457 9H15.1754L12 3.7077L8.82457 9Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCategories);
export default __webpack_public_path__ + "static/media/ic-categories.f5cb833c820e62730873f8b4229c5092.svg";
export { ForwardRef as ReactComponent };